import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class SupportConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getLiveChatUrlEndpoint(): string {
		return this.service.get((x) => x.common.support.endpoints!.liveChatUrl, "v1/support/chats/uri");
	}
}
